<h2 class="default-dialog-header" mat-dialog-title>
	<span fxFlex> {{title}} </span>
	<span *ngIf="termsAgreed" fxFlex fxLayoutAlign="end end">
		<mat-icon (click)="closeDialog()" class="primary-light-color" style="cursor: pointer"
			>close</mat-icon
		>
	</span>
</h2>
<mat-divider></mat-divider>

<mat-dialog-content class="default-dialog-content font-size-12">
	<form [formGroup]="userNameForm" class="m-t-1">
		<div>
			<div *ngIf="isUpdateUserName || isProfileUpdate">
				<mat-form-field class="full-width">
					<input formControlName="firstName" matInput placeholder="First Name" />
				</mat-form-field>
			</div>

			<div *ngIf="isUpdateUserName || isProfileUpdate">
				<mat-form-field class="full-width">
					<input formControlName="lastName" matInput placeholder="Last Name" />
				</mat-form-field>
			</div>

			<div *ngIf="isUpdateBusinessName" fxFlex>
				<mat-form-field class="full-width">
					<input formControlName="businessName" matInput placeholder="Business Name" />
				</mat-form-field>
			</div>

			<div *ngIf="isUpdatePhoneNumber || isProfileUpdate" fxLayoutGap="1rem">
				<mat-form-field class="full-width" fxFlex>
					<input
						[showMaskTyped]="true"
						formControlName="phoneNumber"
						mask="(000) 000-0000"
						matInput
						placeholder="Phone Number"
					/>
					<mat-icon class="primary-light-color" matSuffix>contact_phone</mat-icon>
				</mat-form-field>

				<mat-form-field class="full-width" fxFlex>
					<input
						autocomplete="off"
						formControlName="phoneNumberExt"
						matInput
						placeholder="Extension"
					/>
					<mat-icon class="primary-light-color" matSuffix>contact_phone</mat-icon>
				</mat-form-field>
			</div>

			<div *ngIf="isUpdateMobileNumber || isProfileUpdate" fxLayoutGap="1rem">
				<mat-form-field class="full-width" fxFlex>
					<input
						[showMaskTyped]="true"
						formControlName="mobileNumber"
						mask="(000) 000-0000"
						matInput
						placeholder="Mobile Number"
					/>
					<mat-icon class="primary-light-color" matSuffix>phone_iphone</mat-icon>
				</mat-form-field>
			</div>

			<div *ngIf="!termsAgreed" fxLayoutGap="1rem">
				<mat-checkbox
					[color]=" 'primary' "
					[labelPosition]=" 'after' "
					class="fs-13 m-r-0"
					formControlName="termsAgreed"
				>
					I agree with the&nbsp;
				</mat-checkbox>
				<span
					(click)="openTermsAndConditionsDialog()"
					class="primary-text fs-13 text-underline cursor-pointer"
				>
					Terms and Conditions
				</span>
			</div>
		</div>

		<div class="m-b-1" fxLayoutAlign="end end" fxLayoutGap="1rem">
			<button
				(click)="submit()"
				*ngIf="!isRequestInProgress"
				[disabled]="!userNameForm.valid || !userNameForm.get('termsAgreed').value"
				class="focused-button"
				color="primary"
				mat-raised-button
			>
				Update
			</button>
			<mat-spinner *ngIf="isRequestInProgress" [diameter]="30"></mat-spinner>
		</div>
	</form>
</mat-dialog-content>
